import Axios from "../helpers/axios";

export const verifyRegistrationCode = (body) => {
  return Axios.post("/registration-codes/verify", body);
};
